<!-- eslint-disable -->
<template>
  <div class="crm-kanban-board">
    <!-- Draggable Columns (Deals Pipeline when enabled) -->
    <draggable
      v-if="draggableColumns"
      :list="stages"
      class="d-flex gap-3 align-items-start w-100"
      handle=".crm-column__header"
      @end="handleColumnDragEnd"
    >
      <kanban-column
        v-for="stage in stages"
        :key="stage.id"
        :stage="stage"
        :cards="getCardsForStage(stage.id)"
        :active-pipeline="activePipeline"
        :board-settings="boardSettings"
        :bulk-mode="bulkMode"
        :selected-card-ids="selectedCardIds"
        :total-count="stageCounts[stage.id] !== undefined ? stageCounts[stage.id] : null"
        :loading-more="!!stageLoading[stage.id]"
        @card-moved="$emit('card-moved', $event)"
        @card-click="$emit('card-click', $event)"
        @card-quick-action="$emit('card-quick-action', $event)"
        @card-select="$emit('card-select', $event)"
        @load-more="$emit('load-more', $event)"
      />
    </draggable>

    <!-- Static Columns Layout -->
    <div v-else class="d-flex gap-3 align-items-start w-100">
      <kanban-column
        v-for="stage in stages"
        :key="stage.id"
        :stage="stage"
        :cards="getCardsForStage(stage.id)"
        :active-pipeline="activePipeline"
        :board-settings="boardSettings"
        :bulk-mode="bulkMode"
        :selected-card-ids="selectedCardIds"
        :total-count="stageCounts[stage.id] !== undefined ? stageCounts[stage.id] : null"
        :loading-more="!!stageLoading[stage.id]"
        @card-moved="$emit('card-moved', $event)"
        @card-click="$emit('card-click', $event)"
        @card-quick-action="$emit('card-quick-action', $event)"
        @card-select="$emit('card-select', $event)"
        @load-more="$emit('load-more', $event)"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import draggable from 'vuedraggable'
import KanbanColumn from './KanbanColumn.vue'

export default {
  name: 'KanbanBoard',
  components: {
    draggable,
    KanbanColumn
  },
  props: {
    stages: { type: Array, required: true },
    cards: { type: Array, required: true },
    activePipeline: { type: String, required: true },
    boardSettings: { type: Object, required: true },
    bulkMode: { type: Boolean, default: false },
    selectedCardIds: { type: Array, default: () => [] },
    draggableColumns: { type: Boolean, default: false },
    // Audit A-1: per-stage server totals + per-stage "load more" spinners
    stageCounts: { type: Object, default: () => ({}) },
    stageLoading: { type: Object, default: () => ({}) }
  },
  methods: {
    getCardsForStage(stageId) {
      return this.cards.filter(c => c.stage === stageId)
    },
    handleColumnDragEnd() {
      this.$emit('stage-reorder', { stages: this.stages })
    }
  }
}
</script>

<style lang="scss" scoped>
.crm-kanban-board {
  display: flex;
  overflow-x: auto;
  padding: 1.25rem 2rem 1rem 2rem;
  align-items: flex-start;
  min-height: calc(100vh - 240px);
}

.gap-3 {
  gap: 1.25rem;
}
</style>
